<template>
  <div>
    <v-row dense>
      <v-col
        cols="12"
        md="6"
      >
        <label class="cmr-label-text">Expiry Date</label>
        <DateInputIconV2
          v-model="dateForNewDocument"
          :clearable="true"
        />
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <FileInput
          label="Upload Document"
          icon="insert_drive_file"
          accept="*"
          @fileInput="handleDocumentInput"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col md="12">
        <p
          style="color: red;"
        >
          You must upload a file or ask driver to upload file before you can resolve this document expiry.
        </p>
      </v-col>
    </v-row>
    <v-row class="text-center">
      <v-col md="12">
        <div class="mt-2">
          <v-btn
            class="ma-1"
            v-if="driverDocument.filename"
            small
            color="green lighten-4"
            @click="$emit('viewDocument')"
          >
            Download File
          </v-btn>
          <v-btn
            class="ma-1"
            v-if="driverDocument.filename != null"
            small
            color="red lighten-2"
            @click="reject"
          >
            Reject
          </v-btn>
          <v-btn
            class="ma-1"
            v-if="driverDocument.filename != null || uploadedFile != null"
            small
            color="green"
            @click="accept"
          >
            Accept
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import DateInputIconV2 from '../widget/input/DateInputIconV2'
import FileInput from "@/components/widget/input/FileInputV2.vue";
import axios from 'axios'

export default {
  name: "UploadDriverDocument",
  components: {DateInputIconV2, FileInput},
  props: {
      driverDocument: {
        default: null,
        type: Object
      },
      query: Object,
    driverId: null,
    taxiId: null
  },
  data () {
    return {
      dateForNewDocument: null,
      uploadedFile: null,
      fetchedDriverDocumentURL: null,
      fetchedDriverDocument: null,
      serverItemsLength: null,
      selectedItem: null,
      viewFileDialog: false,
    }
  },
  watch: {
    driverDocument: function (val) {
      this.dateForNewDocument = val.expiry_time;
      if(this.driverDocument.expiry_time === undefined) {
        this.dateForNewDocument = new Date().toISOString().substr(0, 10)
      }
      else {
        this.dateForNewDocument = val.expiry_time;
      }
    }
  },
  mounted() {
    console.log("Mounted: UploadDriverDocument.vue");
    this.dateForNewDocument = this.driverDocument.expiry_time;
    if(this.driverDocument.expiry_time === undefined) {
      this.dateForNewDocument = new Date().toISOString().substr(0, 10)
    }
    else {
      this.dateForNewDocument = this.driverDocument.expiry_time;
    }
  },
  methods: {
    handleDocumentInput(file) {
      console.log("Uploaded file set");
      this.uploadedFile = file;
    },
    async verdict(accept) {
      try {
        let response = await axios.post(
          `${this.$store.state.apiUrl}/driver_document_expiry/documentVerdict?id=${this.driverDocument.id}&accept=${accept}&expiry_time=${this.dateForNewDocument}`,
          {},
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        );

        if (response.data.error == "no_error") {
          this.viewFileDialog = false;
          this.$emit('documentProcessed')
        } else {
          if (response.data.message != null) {
            alert(response.data.message);
          } else {
            alert(response.data.error);
          }
        }
      } catch (error) {
        console.log(error);
        return "unknown_error";
      }
    },
    async uploadAndAccept() {
      this.uploadedFile.expiry_time = this.dateForNewDocument;
      this.uploadedFile.id = this.driverDocument.id;

      console.log(this.uploadedFile);

      console.log("DocType: ", this.driverDocument.value);
      console.log("DriverId: ", this.driverId);
      console.log("TaxiId: ", this.taxiId);

      let docType = this.driverDocument.value == null ? this.driverDocument.type : this.driverDocument.value;

      let document = {
        document_type: docType,
        file: this.uploadedFile,
        expiry_time: this.dateForNewDocument,
        driver_id: this.driverId,
        taxi_id: this.taxiId
      }

      try {
        let response = await axios.post(
          `${this.$store.state.apiUrl}/driver_document_expiry/upload_document`,
          document,
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        );

        if (response.data.error == "no_error") {
          alert("File Uploaded and Expiry Updated");
          this.uploadedFile = null;
          this.$emit('documentProcessed')
        } else {
          if (response.data.message != null) {
            alert(response.data.message);
          } else {
            alert(response.data.error);
          }
        }
      } catch (error) {
        console.log(error);
        return "unknown_error";
      }
    },
    reject() {
      this.verdict(false);
    },
    accept() {
      if (this.uploadedFile != null) {
        this.uploadAndAccept();
      } else {
        this.verdict(true);
      }
    },
  }
}
</script>

<style scoped>

</style>